export default __webpack_public_path__ + "static/media/next_img.687602bf.svg";